import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { useAuth, BugReportModal, useBugReportContext } from '@medprompt/shared';
import { IssueService } from './fetcher';
import './FloatingSupportButton.css';

// Helper function to get view controller name from pathname
const getViewControllerName = (pathname, activeTabLabel) => {
  if (pathname.startsWith('/document-detail')) return 'Document Detail View';
  if (pathname.startsWith('/login')) return 'Login View';
  if (pathname.startsWith('/signup')) return 'Sign Up View';
  if (pathname.startsWith('/verify')) return 'Verify Code View';
  if (pathname === '/') return activeTabLabel + ' View';
  // Add more specific mappings if you have other top-level routes
  // or more complex routing within TabViewController that changes the perceived "view controller"
  return 'Unknown View'; // Default case if no specific match
};

const FloatingSupportButton = ({ activeTabLabel }) => {
  const location = useLocation();
  const { user } = useAuth();
  const { bugContext } = useBugReportContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [issueService] = useState(() => new IssueService());

  const handleReportIssue = () => {
    if (user) {
      // User is authenticated - use modal
      setIsModalOpen(true);
    } else {
      // User is not authenticated - fall back to email
      const viewControllerName = getViewControllerName(location.pathname, activeTabLabel);
      const subject = `SUPPORT - ${viewControllerName}`;
      window.location.href = `mailto:info@medgenixtech.co.uk?subject=${encodeURIComponent(subject)}`;
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleIssueSubmit = async (issueData) => {
    try {
      await issueService.createIssue(issueData);
      console.log('Issue submitted successfully');
      return true;
    } catch (error) {
      console.error('Failed to submit issue:', error);
      throw new Error(error);
    }
  };

  const viewControllerName = getViewControllerName(location.pathname, activeTabLabel);
  const contextInfo = bugContext || '';

  return (
    <>
      <button className="floating-support-button" onClick={handleReportIssue}>
        <FontAwesomeIcon icon={faExclamationTriangle} />
        <span style={{ marginLeft: '8px' }}>Report a problem</span>
      </button>
      
      {user && (
        <BugReportModal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          onSubmit={handleIssueSubmit}
          viewControllerName={viewControllerName}
          contextInfo={contextInfo}
        />
      )}
    </>
  );
};

export default FloatingSupportButton; 